import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';

export const getState = createFeatureSelector<State>('user');

export const getBalance = createSelector(
  getState,
  (state: State) => state.balance.data
);

export const getBalanceLoading = createSelector(
  getState,
  (state: State) => state.balance.loading
);

export const getInfo = createSelector(
  getState,
  (state: State) => state.info.data
);

export const getInfoLoading = createSelector(
  getState,
  (state: State) => state.info.loading
);

export const getRole = createSelector(
  getInfo,
  info => info && info.role
);

export const getToken = createSelector(
  getInfo,
  info => info && info.accessToken
);

export const getOrganizationStatus = createSelector(
  getInfo,
  info => info && info.organizationStatus
);

export const getInfoError = createSelector(
  getState,
  (state: State) => state.info.error
);

export const getMfaId = createSelector(
  getState,
  state => state && state.mfa && state.mfa.mfaId
);

export const getMfa = createSelector(
  getState,
  state => state && state.mfa
);
